import { Component, inject, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackNotificationsDialogService } from '@ui-lib/services';

export interface DialogData {
  label: string;
}

@Component({
  selector: 'secure-message-dialog',
  templateUrl: './secure-message-dialog.component.html',
  styleUrls: ['./secure-message-dialog.component.css'],
  imports: [FormsModule],
})
export class SecureMessageDialogComponent {
  private dialogRef = inject<MatDialogRef<SecureMessageDialogComponent>>(MatDialogRef);
  private snackBar = inject(SnackNotificationsDialogService);

  readonly submitted = output<string>();
  rejectionMessage: string = '';
  needsMessage: boolean = false;
  label = '';

  constructor() {
    const data = inject<DialogData>(MAT_DIALOG_DATA);

    this.label = data?.label || 'Message';
  }

  submitData(): void {
    if (!this.rejectionMessage) {
      this.needsMessage = true;
      this.snackBar.openWarningMessage('Message cannot be empty');
      return;
    }
    this.dialogRef.close(this.rejectionMessage);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  resetMessageStatus() {
    this.needsMessage = false;
  }
}
